import { render } from "./CustomerFormMedium.vue?vue&type=template&id=923a41a6"
import script from "./CustomerFormMedium.vue?vue&type=script&lang=js"
export * from "./CustomerFormMedium.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__